"use strict";

var _interopRequireDefault3 = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Toast;

var _extends2 = _interopRequireDefault3(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault3(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault3(require("@babel/runtime/helpers/objectWithoutProperties"));

var _interopRequireDefault2 = _interopRequireDefault3(require("@babel/runtime/helpers/interopRequireDefault"));

var _AlertMedium = _interopRequireDefault3(require("../../Icon/core/AlertMedium"));

var _Button = _interopRequireDefault3(require("../../Button"));

var _classnames = _interopRequireDefault3(require("classnames"));

var _CrossMedium = _interopRequireDefault3(require("../../Icon/core/CrossMedium"));

var _filterDOMProps = _interopRequireDefault3(require("../../utils/filterDOMProps"));

var _InfoMedium = _interopRequireDefault3(require("../../Icon/core/InfoMedium"));

var _intl = require("../../utils/intl");

var _propTypes = _interopRequireDefault3(require("prop-types"));

var _react = _interopRequireDefault3(require("react"));

var _SuccessMedium = _interopRequireDefault3(require("../../Icon/core/SuccessMedium"));

/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
var intlMessages = {
  "cs-CZ": (0, _interopRequireDefault2["default"])(require("./../intl/cs-CZ.json"))["default"],
  "da-DK": (0, _interopRequireDefault2["default"])(require("./../intl/da-DK.json"))["default"],
  "de-DE": (0, _interopRequireDefault2["default"])(require("./../intl/de-DE.json"))["default"],
  "en-US": (0, _interopRequireDefault2["default"])(require("./../intl/en-US.json"))["default"],
  "es-ES": (0, _interopRequireDefault2["default"])(require("./../intl/es-ES.json"))["default"],
  "fi-FI": (0, _interopRequireDefault2["default"])(require("./../intl/fi-FI.json"))["default"],
  "fr-FR": (0, _interopRequireDefault2["default"])(require("./../intl/fr-FR.json"))["default"],
  "hu-HU": (0, _interopRequireDefault2["default"])(require("./../intl/hu-HU.json"))["default"],
  "it-IT": (0, _interopRequireDefault2["default"])(require("./../intl/it-IT.json"))["default"],
  "ja-JP": (0, _interopRequireDefault2["default"])(require("./../intl/ja-JP.json"))["default"],
  "ko-KR": (0, _interopRequireDefault2["default"])(require("./../intl/ko-KR.json"))["default"],
  "nb-NO": (0, _interopRequireDefault2["default"])(require("./../intl/nb-NO.json"))["default"],
  "nl-NL": (0, _interopRequireDefault2["default"])(require("./../intl/nl-NL.json"))["default"],
  "pl-PL": (0, _interopRequireDefault2["default"])(require("./../intl/pl-PL.json"))["default"],
  "pt-BR": (0, _interopRequireDefault2["default"])(require("./../intl/pt-BR.json"))["default"],
  "ru-RU": (0, _interopRequireDefault2["default"])(require("./../intl/ru-RU.json"))["default"],
  "sv-SE": (0, _interopRequireDefault2["default"])(require("./../intl/sv-SE.json"))["default"],
  "tr-TR": (0, _interopRequireDefault2["default"])(require("./../intl/tr-TR.json"))["default"],
  "uk-UA": (0, _interopRequireDefault2["default"])(require("./../intl/uk-UA.json"))["default"],
  "zh-CN": (0, _interopRequireDefault2["default"])(require("./../intl/zh-CN.json"))["default"],
  "zh-TW": (0, _interopRequireDefault2["default"])(require("./../intl/zh-TW.json"))["default"]
};

if (process.env.SCALE_MEDIUM && process.env.SCALE_LARGE) {
  require("../../spectrum-css/toast/index.css");

  require("../../spectrum-css/toast/index-diff.css");
} else if (process.env.SCALE_LARGE) {
  require("../../spectrum-css/toast/index-lg.css");
} else {
  require("../../spectrum-css/toast/index.css");
}

if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHT) require("../../spectrum-css/toast/multiStops/light.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARK) require("../../spectrum-css/toast/multiStops/dark.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHTEST) require("../../spectrum-css/toast/multiStops/lightest.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARKEST) require("../../spectrum-css/toast/multiStops/darkest.css");
var formatMessage = (0, _intl.messageFormatter)(intlMessages);
var ICONS = {
  error: _AlertMedium["default"],
  warning: _AlertMedium["default"],
  info: _InfoMedium["default"],
  success: _SuccessMedium["default"]
};
var DEFAULT_ROLE = 'alert';

function Toast(_ref) {
  var variant = _ref.variant,
      children = _ref.children,
      closable = _ref.closable,
      onClose = _ref.onClose,
      onAction = _ref.onAction,
      className = _ref.className,
      timeout = _ref.timeout,
      actionLabel = _ref.actionLabel,
      closeOnAction = _ref.closeOnAction,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["variant", "children", "closable", "onClose", "onAction", "className", "timeout", "actionLabel", "closeOnAction"]);
  var Icon = ICONS[variant];
  var role = otherProps.role || DEFAULT_ROLE;

  var handleAction = function handleAction() {
    if (onAction) {
      onAction.apply(void 0, arguments);
    }

    if (closeOnAction && onClose) {
      onClose.apply(void 0, arguments);
    }
  };

  return _react["default"].createElement("div", (0, _extends2["default"])({
    role: role,
    className: (0, _classnames["default"])('spectrum-Toast', (0, _defineProperty2["default"])({}, 'spectrum-Toast--' + variant, variant), className)
  }, (0, _filterDOMProps["default"])(otherProps)), Icon && _react["default"].createElement(Icon, {
    size: null,
    className: "spectrum-Toast-typeIcon",
    alt: formatMessage(variant)
  }), _react["default"].createElement("div", {
    className: "spectrum-Toast-body"
  }, _react["default"].createElement("div", {
    className: "spectrum-Toast-content"
  }, children), actionLabel && _react["default"].createElement(_Button["default"], {
    label: actionLabel,
    quiet: true,
    variant: "overBackground",
    onClick: handleAction
  })), closable && _react["default"].createElement("div", {
    className: "spectrum-Toast-buttons"
  }, _react["default"].createElement("button", {
    "aria-label": formatMessage('close'),
    className: "spectrum-ClearButton spectrum-ClearButton--medium spectrum-ClearButton--overBackground",
    onClick: onClose
  }, _react["default"].createElement(_CrossMedium["default"], {
    size: null
  }))));
}

Toast.propTypes = {
  /** Contents to be displayed in the Toast. */
  children: _propTypes["default"].node,

  /** Variant of toast to use. */
  variant: _propTypes["default"].oneOf(['error', 'warning', 'info', 'success']),

  /** Whether to show close button on toast. */
  closable: _propTypes["default"].bool,

  /** Label for action button. */
  actionLabel: _propTypes["default"].string,

  /** Should the action button close the toast? */
  closeOnAction: _propTypes["default"].bool,

  /** Function called when toast is closed. */
  onClose: _propTypes["default"].func,

  /** Function called when action button is clicked. */
  onAction: _propTypes["default"].func,

  /**
   * Set the amount of time in milliseconds that the toast should persist.
   * If set to 0, the toast will remain until closed manually.
  */
  timeout: _propTypes["default"].number
};